const video = document.querySelector('.myVideo');
const videoContainer = document.querySelector('.video-container');
const iconPlay = document.querySelector('.play-icon');
const iconPause = document.querySelector('.pause-icon');
let hideButtonTimeout;

const overlay = document.createElement('div');
overlay.classList.add('overlay');
videoContainer.appendChild(overlay);

iconPlay.classList.add('show');
overlay.style.display = 'block';
iconPause.classList.remove('show');

iconPlay.addEventListener('click', () => {
  video.play();
  overlay.style.display = 'none';
  iconPlay.classList.remove('show');
  iconPause.classList.add('show');
  hidePlayPauseButton();

  if (!video.hasClickHandler) {
    video.addEventListener('click', () => {
      if (!video.paused) {
        iconPause.classList.add('show');
      }
    });
    video.hasClickHandler = true;
  }
});

iconPause.addEventListener('click', () => {
  video.pause();
  overlay.style.display = 'block';
  iconPlay.classList.add('show');
  iconPause.classList.remove('show');
});

video.addEventListener('ended', () => {
  overlay.style.display = 'block';
  iconPlay.classList.add('show');
  iconPause.classList.remove('show');
});

function hidePlayPauseButton() {
  clearTimeout(hideButtonTimeout);
  hideButtonTimeout = setTimeout(() => {
    if (!video.paused) {
      iconPlay.classList.remove('show');
      iconPause.classList.remove('show');
    }
  }, 1000);
}

function checkScreenWidth() {
  if (window.innerWidth >= 1200) {
    videoContainer.addEventListener('mouseover', handleMouseOver);
    videoContainer.addEventListener('mouseleave', handleMouseLeave);
  } else {
    videoContainer.removeEventListener('mouseover', handleMouseOver);
    videoContainer.removeEventListener('mouseleave', handleMouseLeave);
  }
}

function handleMouseOver() {
  if (!video.paused) {
    iconPause.classList.add('show');
  }
}

function handleMouseLeave() {
  iconPause.classList.remove('show');
}

checkScreenWidth();

window.addEventListener('resize', checkScreenWidth);
